export var K_BYTE = 1024;
export var M_BYTE = 1024 * K_BYTE;
export function sizeOf(str) {
    var total = 0;
    for (var i = 0, len = str.length; i < len; i++) {
        var charCode = str.charCodeAt(i);
        if (charCode <= 0x007f) {
            total += 1;
        }
        else if (charCode <= 0x07ff) {
            total += 2;
        }
        else if (charCode <= 0xffff) {
            total += 3;
        }
        else {
            total += 4;
        }
    }
    return total;
}
export function isValidDay(day) {
    if (typeof day !== 'string') {
        return false;
    }
    else {
        var dayParts = day.split('-');
        var M = parseInt(dayParts[1]);
        var D = parseInt(dayParts[2]);
        return (M > 0 &&
            M <= 12 &&
            D > 0 &&
            D <= 31 &&
            new Date(day).toString() !== 'Invalid Date');
    }
}
export function dateFormat2Day(date) {
    var Y = date.getFullYear();
    var M = date.getMonth() + 1;
    var D = date.getDate();
    return Y + "-" + (M < 10 ? '0' + M : M) + "-" + (D < 10 ? '0' + D : D);
}
export function getStartOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}
export function dayFormat2Date(day) {
    var _a = (day.match(/(\d+)/g) || []).map(function (n) { return parseInt(n); }), year = _a[0], month = _a[1], date = _a[2];
    if (year < 1000) {
        throw new Error("Invalid dayString: " + day);
    }
    return new Date(year, month - 1, date);
}
export var ONE_DAY_TIME_SPAN = 24 * 60 * 60 * 1000;
export function arrayGroupByKey(arr, key) {
    var result = {};
    return arr.reduce(function (acc, item) {
        var k = item[key];
        if (!acc[k])
            acc[k] = [];
        acc[k].push(item);
        return acc;
    }, result);
}
export function logContentWrapper(content, logType) {
    var logOb = {
        t: logType,
        c: content,
        d: Date.now()
    };
    return logOb;
}
export function allSettled(promises) {
    if (promises.length === 0)
        return Promise.resolve([]);
    var _promises = promises.map(function (item) { return item instanceof Promise ? item : Promise.resolve(item); });
    return new Promise(function (resolve, reject) {
        var result = [];
        var unSettledPromiseCount = _promises.length;
        _promises.forEach(function (promise, index) {
            promise.then(function (value) {
                result[index] = {
                    status: 'fulfilled',
                    value: value
                };
                unSettledPromiseCount -= 1;
                // resolve after all are settled
                if (unSettledPromiseCount === 0) {
                    resolve(result);
                }
            }, function (reason) {
                result[index] = {
                    status: 'rejected',
                    reason: reason
                };
                unSettledPromiseCount -= 1;
                // resolve after all are settled
                if (unSettledPromiseCount === 0) {
                    resolve(result);
                }
            });
        });
    });
}
/**
 * uuid获取
 * @param randomLength 长度控制
 * @returns
 */
export function getUUID(randomLength) {
    return Number(Math.random().toString().substr(2, randomLength) + Date.now()).toString(36);
}
export function getPID() {
    return getUUID(10);
}
export var parseParams = function (uri, params) {
    var paramsArray = [];
    Object.keys(params).forEach(function (key) { return params[key] && paramsArray.push(key + "=" + params[key]); });
    if (uri.search(/\?/) === -1) {
        uri += "?" + paramsArray.join('&');
    }
    else {
        uri += "&" + paramsArray.join('&');
    }
    return uri;
};
export var isLikeelive = navigator.userAgent.match(/(bigo-baiguoyuan).*(_like_|_bigolike_)/i);
export var isBigolive = navigator.userAgent.match(/(bigo-baiguoyuan).*(_bigolive_)/i);
export var REPORT_QUERY = {
    default: '?uri=26348&aid=60',
    hello: '?uri=26348&aid=18'
};
